import React from 'react';
import { Asset } from 'contentful';

import { getImageData } from '../../../../utils/contentful';

import { Text } from '../../../Text';
import { Box } from '../../../Box';
import { Column, Layout } from '../../../Layout';
import CtaWidget from '../../../CtaWidget';
import { AffiliateLogoGrouping } from '../AffiliateLogoGrouping';
import PrivacyPolicyDisclaimer from '../../../FullwidthHero/PrivacyPolicyDisclaimer';

import {
  DesktopBlockContainer,
  SubheadText,
  SpacerColumn
} from '../../../FullwidthHero/styles';

import { DesktopImage } from '../styles';

import { AffiliateHero2Props } from '../index';

export default function DesktopView({
  headingText,
  useLightHeadingText,
  subheadingText,
  subheadingSize,
  useLightSubheadingText,
  fullwidthDesktopImage,
  desktopCta,
  affiliateLogo,
  useGreenlightIcon,
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon,
  sendConsentEvent
}: AffiliateHero2Props) {
  const visibility = fullwidthDesktopImage ? 'visible' : 'hidden';

  return (
    <DesktopBlockContainer
      as="section"
      marginTop={{
        0: 'blockMarginY',
        tablet: 'blockMarginY_tablet'
      }}
      marginBottom={{
        0: 'blockMarginY',
        tablet: '3xl'
      }}
      revealOnScroll={false}
      data-blockid="affiliate-hero-20-hero-desktop"
    >
      <Layout gutter={{ tablet: 'collapsibleVert' }} marginTop="s">
        <SpacerColumn size={1} />
        <Column
          size={{ tablet: 5 }}
          flexDirection="column"
          justifyContent="center"
        >
          <AffiliateLogoGrouping
            affiliateLogo={affiliateLogo}
            useGreenlightIcon={useGreenlightIcon}
          />
          <Text
            as="h1"
            fontWeight="h1"
            fontSize={{ 0: 'h1_0', desktop: 'h1_tablet' }}
            colour={useLightHeadingText ? 'white' : 'defaultText'}
            textAlign="left"
            marginTop={0}
            marginBottom="m"
            data-testid="affiliate-hero-20-headline-desktop"
            dangerouslySetInnerHTML={{
              __html: headingText || ''
            }}
          />
          <SubheadText
            as="h2"
            data-testid="affiliate-hero-20-subhead-desktop"
            fontWeight="p"
            subheadingSize={subheadingSize || '1.75'}
            colour={useLightSubheadingText ? 'white' : 'defaultText'}
            textAlign="left"
            marginTop={0}
            marginBottom="ml"
          >
            {subheadingText}
          </SubheadText>

          {desktopCta && (
            <Box data-testid="affiliate-hero-desktop-cta">
              <CtaWidget
                {...desktopCta?.fields}
                id="affiliate-hero-desktop-cta-widget"
                sysId={desktopCta?.sys?.contentType?.sys?.id}
                module="Hero"
                sendConsentEvent={sendConsentEvent}
              />
            </Box>
          )}

          {privacyPolicyDisclaimer && (
            <Box marginTop="ml">
              <PrivacyPolicyDisclaimer
                privacyPolicyDisclaimer={privacyPolicyDisclaimer}
                displayPrivacyPolicyIcon={displayPrivacyPolicyIcon}
              />
            </Box>
          )}
        </Column>
        <Column size={{ tablet: 7, desktop: 6 }}>
          <Box flex="1" style={{ position: 'relative' }}>
            <DesktopImage
              {...getImageData(fullwidthDesktopImage as Asset)}
              visibility={visibility}
              heroImage={true}
              loading="eager"
            />
          </Box>
        </Column>
      </Layout>
    </DesktopBlockContainer>
  );
}
